// import {changeHeaderTitleAC} from "../../Redux/HeaderReducer/actions";
import {connect} from "react-redux";
import {getAggregatedWords} from "../../Redux/GamesReducer/thunk";
import GamePreview from "./GamePreview";





const GamePreviewContainer = GamePreview


export default GamePreviewContainer;
